import api from "../api/axios";

const WarehouseService = {
  getAll: async () => {
    const response = await api.get("/Warehouse/all");
    return response.data;
  },
  getById: async (id) => {
    const response = await api.get(`/Warehouse/${id}`);
    return response.data;
  },
  getDetail: async (id) => {
    const response = await api.get(`/Warehouse/detail/${id}`);
    return response.data;
  },
  create: async (dto) => {
    const response = await api.post("/Warehouse/create", dto);
    return response.data;
  },
  update: async (dto) => {
    const response = await api.post("/Warehouse/update", dto);
    return response.data;
  },
};

export default WarehouseService;
